module.exports = __webpack_public_path__ + "feb3bd85e4774995ec0d96ae5ad5e4c1.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/forms/tour/tip-lightbulb-copy-3.svg
// module id = 738
// module chunks = 0